import { createCalendar, ZonedDateTime } from '@internationalized/date';
import { useCalendar, AriaCalendarProps, DateValue } from '@react-aria/calendar';
import { useDateFormatter } from '@react-aria/i18n';
import { useCalendarState } from '@react-stately/calendar';

import { fontStyles } from '@/styles/typography';

import { DropDownLeftArrow } from '@/ui/Icons/DropDownLeftArrow';
import { DropDownRightArrow } from '@/ui/Icons/DropDownRightArrow';

import { CalendarNavigationButton } from './CalendarButton';
import { Grid } from './CalendarGrid';

interface ExpiryCalendarProps extends AriaCalendarProps<DateValue> {
  now: ZonedDateTime;
}

/**
 * Expiry Calendar
 */
export const ExpiryCalendar = ({ now, ...props }: ExpiryCalendarProps) => {
  const calendarState = useCalendarState({
    ...props,
    locale: 'en-US',
    createCalendar,
  });
  const { calendarProps, prevButtonProps, nextButtonProps } = useCalendar(props, calendarState);
  const monthDateFormatter = useDateFormatter({
    month: 'long',
    year: 'numeric',
    timeZone: calendarState.timeZone,
  });

  return (
    <div {...calendarProps}>
      <div className="flex justify-between items-center mb-2">
        <CalendarNavigationButton {...prevButtonProps}>
          <DropDownLeftArrow />
        </CalendarNavigationButton>
        <h2 className={fontStyles({ variant: 'LABEL_MD', class: 'flex text-center' })}>
          {monthDateFormatter.format(
            calendarState.visibleRange.start.toDate(calendarState.timeZone),
          )}
        </h2>
        <CalendarNavigationButton {...nextButtonProps}>
          <DropDownRightArrow />
        </CalendarNavigationButton>
      </div>
      <Grid state={calendarState} now={now} />
    </div>
  );
};
